import React from 'react';

interface MessageAlertsProps {
  success?: string | null;
  error?: string | null;
  cameraError?: string | null;
  onClearError: () => void;
  onClearSuccess: () => void;
  onShowManualInput: () => void;
  onRetryScanner: () => void;
}

const MessageAlerts: React.FC<MessageAlertsProps> = ({
  success,
  error,
  cameraError,
  onClearError,
  onClearSuccess,
  onShowManualInput,
  onRetryScanner,
}) => {
  // Only render if there are alerts to show
  if (!success && !error && !cameraError) {
    return null;
  }

  return (
    <div className="space-y-4 mb-2">
      {success && (
        <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg">
          <div className="flex justify-between items-center">
            <p className="text-sm">{success}</p>
            <button onClick={onClearSuccess} className="text-green-500 hover:text-green-700">
              ×
            </button>
          </div>
        </div>
      )}

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
          <div className="flex justify-between items-center">
            <p className="text-sm">{error}</p>
            <button onClick={onClearError} className="text-red-500 hover:text-red-700">
              ×
            </button>
          </div>
        </div>
      )}

      {cameraError && (
        <div className="bg-yellow-50 border border-yellow-200 text-yellow-700 px-4 py-3 rounded-lg">
          <div className="flex justify-between items-center">
            <div className="flex-1">
              <p className="text-sm">{cameraError}</p>
              <div className="mt-2 space-x-2">
                <button
                  onClick={onRetryScanner}
                  className="text-xs bg-yellow-100 hover:bg-yellow-200 px-2 py-1 rounded"
                >
                  Retry Scanner
                </button>
                <button
                  onClick={onShowManualInput}
                  className="text-xs bg-yellow-100 hover:bg-yellow-200 px-2 py-1 rounded"
                >
                  Manual Ticket Input
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageAlerts;
